import { StyleSheet } from 'react-native'

const useStyles = (isTablet) => StyleSheet.create({
  container: {
    paddingHorizontal: isTablet ? 40 : 20
  },
  driverContainer: {
    marginTop: 20
  },
  driverRow: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    marginBottom: 20
  },
  divider: {
    marginVertical: 20
  },
  tractorInformation: {
    flexDirection: 'row'
  },
  tractorType: {
    flex: 2
  },
  number: {
    flex: 1,
    marginLeft: 5
  },
  numbersContainer: {
    flexDirection: 'row',
    marginVertical: 20
  },
  buttonContainer: {
    marginBottom: 20
  },
  tractorNumber: {
    flex: 1,
    marginRight: 6
  },
  trailerNumber: {
    flex: 1,
    marginLeft: 6
  }
})

export default useStyles
